<template lang="pug">
  ul.TheHeaderMenu.header-menu(
    aria-label="Header menu"
  )
    template(
      v-for="menuItem in children",
    )
      TheHeaderMenuItem(
        :key="menuItem.slug",
        v-bind="menuItem",
        v-if="visibleMenuList.includes(menuItem.slug)"
      )
</template>

<script>
import { mapGetters } from 'vuex';
import TheHeaderMenuItem from './TheHeaderMenuItem';

export default {
  name: 'TheHeaderMenu',
  components: {
    TheHeaderMenuItem,
  },
  props: {
    children: Array,
  },
  computed: {
    ...mapGetters('login', [
      'isLoggedIn',
    ]),
    visibleMenuList() {
      if (this.isLoggedIn) return ['investments', 'portfolio', 'resources'];
      return ['investments', 'farm-owners', 'advisors', 'resources'];
    },
  },
};
</script>

<style lang="sass" scoped>
.header-menu
  align-items: center
  justify-content: center
  display: flex
  list-style-type: none
  @media screen and (max-width: 991px)
    display: none
</style>
